// All editable content for the MARIE-JOSEPH site lives here.
// Swap image URLs and copy in this single file.

export const ASSETS = {
  heroVideo:
    "https://customer-assets.emergentagent.com/job_cbf5ed52-f241-446d-bcdb-82fe7d54ec46/artifacts/3dix8hrt_Alonso%20broll%20.mp4",
  yacht: {
    aerialSolar:
      "https://customer-assets.emergentagent.com/job_marie-joseph-sunreef/artifacts/bof9zvo4_Sunreef%2080%20Eco%20%2813%29.jpg",
    sunsetWide:
      "https://customer-assets.emergentagent.com/job_marie-joseph-sunreef/artifacts/nsp9b9ir_Sunreef%2080%20Eco%20%2814%29.jpg",
    bowCityscape:
      "https://customer-assets.emergentagent.com/job_marie-joseph-sunreef/artifacts/kdqdfnk7_Sunreef%2080%20Eco%20%2812%29.jpg",
    anchorRocks:
      "https://customer-assets.emergentagent.com/job_marie-joseph-sunreef/artifacts/lebp5ohk_Sunreef%2080%20Eco%20%2810%29.jpg",
    anchorRocks2:
      "https://customer-assets.emergentagent.com/job_marie-joseph-sunreef/artifacts/1p3ogiac_Sunreef%2080%20Eco%20%2811%29.jpg",
    bowSailing:
      "https://customer-assets.emergentagent.com/job_marie-joseph-sunreef/artifacts/o8og5d9v_Sunreef%2080%20Eco%20%285%29.jpg",
    sunsetSail:
      "https://customer-assets.emergentagent.com/job_marie-joseph-sunreef/artifacts/qnk8rjmc_Sunreef%2080%20Eco%20%284%29.jpg",
    bwFullSail:
      "https://customer-assets.emergentagent.com/job_marie-joseph-sunreef/artifacts/hzxnbdzz_Sunreef%2080%20Eco%20%283%29.jpg",
    sunsetProfile:
      "https://customer-assets.emergentagent.com/job_marie-joseph-sunreef/artifacts/8vdy3bep_Sunreef%2080%20Eco%20%281%29.jpg",
    profileSail:
      "https://customer-assets.emergentagent.com/job_marie-joseph-sunreef/artifacts/g54jyru8_Sunreef%2080%20Eco%20%282%29.jpg",
    bowDetail:
      "https://customer-assets.emergentagent.com/job_marie-joseph-sunreef/artifacts/qe4njo1p_Sunreef%2080%20Eco%20%2846%29.jpg",
    flybridgeDining:
      "https://customer-assets.emergentagent.com/job_marie-joseph-sunreef/artifacts/alulk129_JC-019564.jpg",
  },
  // Generic / atmospheric placeholders for things we don't have specific shots of
  atmospheric: {
    calmSea:
      "https://images.pexels.com/photos/1212600/pexels-photo-1212600.jpeg?auto=compress&cs=tinysrgb&w=1920",
    solarTexture:
      "https://images.pexels.com/photos/18306342/pexels-photo-18306342.jpeg?auto=compress&cs=tinysrgb&w=1920",
    interior:
      "https://images.unsplash.com/photo-1697124510322-27ef594f67fd?auto=format&fit=crop&w=1600&q=80",
    salon:
      "https://images.unsplash.com/photo-1559385301-0187cb6eff46?auto=format&fit=crop&w=1600&q=80",
  },
};

export const HERO = {
  overline: "Sunreef 80 Eco · Hull 01",
  title: "Own the yacht that\nchanged sustainable\nluxury sailing.",
  subhead:
    "MARIE-JOSEPH is the founder-owned, award-winning original Sunreef 80 Eco — built for Francis Lapp, named in tribute to his parents, and created as a full expression of sustainable yachting.",
  ctaPrimary: "View Specifications",
  ctaSecondary: "Explore Provenance",
};

export const FOUNDER = {
  overline: "Founder Provenance",
  title: "Built for the founder\nof Sunreef Yachts.",
  body:
    "Built and designed for Francis Lapp, Founder and President of Sunreef Yachts — the personal proof point for the Eco philosophy.",
  quote:
    "Marie & Joseph is a yacht I have built as a tribute to my parents. After enjoying numerous wonderful moments on board in the most beautiful corners of the world, the time has come to engage in a new yacht building project. This Sunreef 80 Eco profits from all our R&D expertise as a shipyard and is the full expression of sustainable yachting.",
  attribution: "Francis Lapp — Founder & President, Sunreef Yachts",
};

export const TRIBUTE = {
  overline: "A Tribute",
  title: "A name carried\nfrom shore to sea.",
  body:
    "The name MARIE-JOSEPH carries personal meaning. Francis Lapp has described the yacht as a tribute to his parents and to the values that shaped his path: work, resilience, gratitude, and vision.",
  quote:
    "Without my parents, I would not be where I am today. I grew up in a very modest environment, and my parents taught me the value of hard work. The name of this yacht is a tribute to them and a way to thank them.",
  attribution: "Francis Lapp",
};

export const TECH = {
  overline: "Sustainable Technology",
  title: "Silent power.\nFull luxury.",
  body:
    "The Sunreef 80 Eco is engineered around clean propulsion from the keel up — never retrofitted.",
  features: [
    {
      label: "Electric propulsion",
      desc: "Silent, fume-free cruising. Zero-emission anchorages.",
    },
    {
      label: "Integrated solar skin",
      desc: "Composite-integrated photovoltaics across the superstructure.",
    },
    {
      label: "Hydrogeneration under sail",
      desc: "Propellers act as turbines, recharging the bank as she glides.",
    },
    {
      label: "High-capacity battery bank",
      desc: "Onboard storage for propulsion, hotel loads, and silent overnight stays.",
    },
    {
      label: "Advanced energy management",
      desc: "Real-time monitoring across generation, storage, and consumption.",
    },
    {
      label: "No aesthetic compromise",
      desc: "Eco systems concealed behind Sunreef's signature lines.",
    },
  ],
  disclaimer:
    "Public-source values for solar kWp, battery capacity, and range vary. Exact figures provided on request.",
  stats: [
    { value: 8, label: "Guests" },
    { value: 4, label: "Cabins" },
    { value: 4, label: "Crew" },
  ],
};

export const GALLERY = [
  { key: "exterior", label: "Exterior", img: "yacht.anchorRocks" },
  { key: "under-sail", label: "Under Sail", img: "yacht.profileSail" },
  { key: "solar-skin", label: "Solar Skin", img: "yacht.bowDetail" },
  { key: "flybridge", label: "Flybridge", img: "yacht.flybridgeDining" },
  { key: "aft-deck", label: "Aft Deck", img: "yacht.bowSailing" },
  { key: "salon", label: "Salon", img: "atmospheric.salon" },
  { key: "cabins", label: "Cabins", img: "atmospheric.interior" },
  { key: "at-anchor", label: "At Anchor", img: "yacht.sunsetWide" },
  { key: "founder-onboard", label: "Francis Lapp Onboard", img: "yacht.bwFullSail" },
];

export const AWARDS = {
  overline: "Recognition",
  title: "Awarded.\nDocumented.\nIcon-grade.",
  primaryAward: {
    title: "YCM Explorer Award",
    year: "2023",
    category: "Technology & Innovation",
    venue: "Yacht Club de Monaco",
    description:
      "Recognized for advancing sustainable propulsion in superyacht catamarans.",
  },
  secondary: [
    {
      title: "International Yachting Media",
      desc: "Featured across leading luxury and yachting publications.",
    },
    {
      title: "Reference Platform",
      desc: "The shipyard's first-hull reference for the entire 80 Eco range.",
    },
  ],
  note:
    "Some mentions apply to the Sunreef 80 Eco model range — verify before presenting as hull-specific.",
};

export const SPECS = {
  overline: "Specifications",
  title: "Verified facts &\npublic-source notes.",
  verified: [
    { k: "Yacht name", v: "MARIE-JOSEPH / Marie-Joseph" },
    { k: "Model", v: "Sunreef 80 Eco" },
    { k: "Builder", v: "Sunreef Yachts" },
    { k: "Guests", v: "8" },
    { k: "Cabins", v: "4" },
    { k: "Crew", v: "4 (per broker / charter sources)" },
  ],
  publicSource: [
    { k: "Length", v: "≈ 23.87 m – 24.38 m", note: "Public sources vary" },
    { k: "Beam", v: "≈ 11.28 m – 12.00 m", note: "Public sources vary" },
    { k: "Draft", v: "2.2 m", note: "Per charter sources" },
    { k: "Cruising speed", v: "8 knots", note: "Per charter sources" },
    { k: "Max speed", v: "11 knots", note: "Per charter sources" },
    {
      k: "Asking price",
      v: "€7,500,000",
      note: "Some older syndicated listings show €7,900,000",
    },
  ],
  toConfirm: [
    { k: "VAT status", v: "Not reliably confirmed publicly", note: "Confirm on enquiry" },
    { k: "Current location", v: "Public listings vary", note: "Confirm on enquiry" },
    { k: "Flag / registration", v: "Public sources conflict", note: "Confirm on enquiry" },
  ],
};

export const OPPORTUNITY = {
  overline: "Immediate Opportunity",
  title: "A rare opportunity\nwithout the wait.",
  body:
    "New-build yachts require time. MARIE-JOSEPH offers something different: a founder-owned Sunreef 80 Eco, ready now.",
  cta: "Request Sales Dossier",
};

export const COMPARISON = {
  overline: "Positioning",
  title: "Why MARIE-JOSEPH\nsits apart.",
  columns: [
    "MARIE-JOSEPH",
    "Other Sunreef 80 Eco",
    "Sunreef 70",
    "Sunreef 60 Eco",
    "Silent Yachts",
    "Lagoon Seventy 7",
  ],
  rows: [
    { trait: "Founder provenance", values: ["yes", "no", "no", "no", "no", "no"] },
    { trait: "First-hull / signature yacht", values: ["yes", "no", "no", "no", "no", "no"] },
    { trait: "Sustainable propulsion", values: ["yes", "yes", "no", "yes", "yes", "no"] },
    { trait: "Award recognition", values: ["yes", "varies", "varies", "varies", "yes", "varies"] },
    { trait: "Immediate availability", values: ["yes", "varies", "varies", "varies", "varies", "varies"] },
    { trait: "Collector-grade narrative", values: ["yes", "no", "no", "no", "no", "no"] },
  ],
};

export const FINAL_CTA = {
  overline: "Marie-Joseph",
  title:
    "The original Sunreef 80 Eco.\nFounder-owned.\nAward-recognized.\nReady for its next chapter.",
  primary: "Enquire About MARIE-JOSEPH",
  secondary: "Download Full Dossier",
  email: "enquiries@marie-joseph.example",
  dossierUrl:
    "https://customer-assets.emergentagent.com/job_marie-joseph-sunreef/artifacts/tvg33cli_Marie%20Joseph_Sunreef%2080%20Eco_BF.pdf",
};
